export const canGoBack = (): boolean => window.history?.state?.idx > 0;
